import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import agendaImg from "../../img/accueil_concept4.png";
import EventCard from "../../components/eventCard/EventCard";
import { fetchEvenementsPublic } from "../../redux/agendaSlice";

function Agenda() {
  const dispatch = useDispatch();
  const { evenements, loading, error } = useSelector((state) => state.agenda);

  useEffect(() => {
    dispatch(fetchEvenementsPublic());
  }, [dispatch]);

  return (
    <div className="w-full bg-white">
      <section className="max-w-6xl mx-auto px-4 md:px-8 lg:px-12 py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-2">
          Événements à venir
        </h1>
        <p className="text-slate-600 mb-8 text-lg">
          Découvrez nos prochains ateliers et événements spéciaux.
        </p>

        {loading && (
          <p className="text-slate-400 italic">Chargement des événements…</p>
        )}

        {error && (
          <p className="text-red-500 text-sm">
            Impossible de charger les événements. Veuillez réessayer plus tard.
          </p>
        )}

        {!loading && !error && evenements.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {evenements.map((ev) => (
              <EventCard key={ev.evenement_id} evenement={ev} />
            ))}
          </div>
        )}

        {!loading && !error && evenements.length === 0 && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center mt-4">
            <div className="w-full rounded-2xl overflow-hidden shadow-lg bg-orange-50 max-h-[600px]">
              <img
                src={agendaImg}
                alt="Agenda Mood"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex flex-col gap-4">
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900">
                Aucun événement prévu pour le moment !
              </h2>
              <p className="text-slate-700 leading-relaxed">
                Mais on travaille activement pour vous proposer des choses rapidement !
              </p>
              <p className="text-slate-700 leading-relaxed">See you soon !</p>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}

export default Agenda;
